import { render, staticRenderFns } from "./newsText.vue?vue&type=template&id=7e54b208&scoped=true&"
import script from "./newsText.vue?vue&type=script&lang=js&"
export * from "./newsText.vue?vue&type=script&lang=js&"
import style0 from "./newsText.vue?vue&type=style&index=0&id=7e54b208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54b208",
  null
  
)

export default component.exports